'use client'

import { create } from 'zustand'

type StreamDebugState = {
  rawStreamContent: string
  isEnabled: boolean
  appendContent: (chunk: string) => void
  clearContent: () => void
  setEnabled: (enabled: boolean) => void
}

export const useStreamDebugStore = create<StreamDebugState>((set) => {
  return {
    rawStreamContent: '',
    isEnabled: false,
    appendContent: (chunk: string) => {
      set((state) => {
        return {
          rawStreamContent: state.rawStreamContent + chunk,
        }
      })
    },
    clearContent: () => {
      set({ rawStreamContent: '' })
    },
    setEnabled: (enabled: boolean) => {
      set({ isEnabled: enabled })
    },
  }
})
